import { render, staticRenderFns } from "./CpttList.vue?vue&type=template&id=804f55e4&scoped=true&"
import script from "./CpttList.vue?vue&type=script&lang=js&"
export * from "./CpttList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804f55e4",
  null
  
)

export default component.exports